import { useFetch } from '@/modules/common';

import { SystemPromptResponse } from '../types';

export function useSystemPromptContent() {
  const fetchClient = useFetch();

  const fetchContent = async (promptId: string): Promise<string> => {
    const data = (await fetchClient(
      `/system-prompts/${promptId}`
    )) as SystemPromptResponse;
    return data.content;
  };

  return { fetchContent };
}
